module.exports = __webpack_public_path__ + "img/time.a121c85d.png";